const NAV_TYPE = {
  INTRO: 1,
  TECH: 2,
  SPOT: 3,
  WHY: 4
}

export default NAV_TYPE;
